/*
 * Module for the scheduled status area of a topic page
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicScheduledStatus/topicScheduledStatusView",
  "modules/topicsSplit/topic/topicScheduledStatusModal/topicScheduledStatusModalModule",
], function (Marionette, Messenger, TopicScheduledStatusView, TopicScheduledStatusModalModule) {
  "use strict";

  const SHOW_MODAL_TIMEOUT = 500;

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicScheduledStatus";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (topic) {
      this.topic = topic;
      const scheduledStatus = topic.scheduledStatus();
      scheduledStatus.onSynced(() => {
        this.view = new TopicScheduledStatusView.topicScheduledStatusView({
          model: scheduledStatus,
        });
        this.view.on("edit:scheduled:status", this.showModal, this);
        this.showRegion(this.view);
      });
    },
    showModal: function () {
      //open scheduled status modal
      const currentStatus = this.topic.getStatus();
      const scheduledStatus = this.topic.scheduledStatus();
      Messenger.vent.trigger(
        "show:modal",
        TopicScheduledStatusModalModule,
        {},
        {
          scheduledStatus: scheduledStatus,
          currentStatusId: currentStatus,
          topic: this.topic,
        },
        {
          title: "topic.scheduledStatus.title",
          closeButton: false,
          closeOnBackgroundClick: false,
          trackInteraction: {
            action: "Schedule Topic Status",
            id: this.topic.id,
            idType: "Topic",
            object: "Topic",
          },
        },
      );
    },
    _saveAndSelectResponseTemplateIds: function () {
      Messenger.save((success) => {
        if (success) {
          const topic = this.topic;
          const responseTemplateIds = topic.conversation()._getSelectedTemplates();
          topic.conversation().selectedResponses = [];
          topic.scheduledStatus().set("responseTemplateIds", responseTemplateIds);
        }
        setTimeout(() => this.showModal(), SHOW_MODAL_TIMEOUT);
      });
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "topicScheduleStatus:publish:pending:responses",
        this._saveAndSelectResponseTemplateIds,
        this,
      );
      Messenger.vent.on(
        "topicScheduleStatus:enable:selected:responses",
        this._saveAndSelectResponseTemplateIds,
        this,
      );
      Messenger.vent.on(
        "topicScheduleStatus:disable:selected:responses",
        this._saveAndSelectResponseTemplateIds,
        this,
      );
      Messenger.vent.on("topicScheduleStatus:cancel:pending:responses", () =>
        setTimeout(() => this.showModal(), SHOW_MODAL_TIMEOUT),
      );
      Messenger.vent.on("topicScheduleStatus:cancel:disable:responses", () =>
        setTimeout(() => this.showModal(), SHOW_MODAL_TIMEOUT),
      );
      Messenger.vent.on("topicScheduleStatus:cancel:enable:responses", () =>
        setTimeout(() => this.showModal(), SHOW_MODAL_TIMEOUT),
      );
    },
  });
});
